import React, { FC, MouseEvent, useCallback } from "react";
import { List, Map } from "immutable";
import { Hidden } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import styled from "styled-components";
import { OpenRightPanel } from "types/common/rightPanel";
import { setSelectedPassportId } from "../../../../reduxFolder/reducers/books";
import { openRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import { selectedPassportId } from "../../../../reduxFolder/selectors/booksSelectors";
import { TableCol, TableRow } from "../../styles/BookRecipients.style";
import BooksPassportItemRow from "./BooksPassportItemRow";

interface BooksPassportsListProps {
  passportItems: List<any>;
  disabled: boolean;
  openRightPanel: OpenRightPanel;
  selectedPassportId: number | null;
  setSelectedPassportId: (id: number) => void;
}

const BooksPassportsList: FC<BooksPassportsListProps> = React.memo(
  ({
    passportItems,
    disabled,
    openRightPanel,
    selectedPassportId,
    setSelectedPassportId,
  }) => {
    const viewPassport = useCallback(
      (event: MouseEvent, item: any) => {
        setSelectedPassportId(item.get("id"));
        event.stopPropagation();
        openRightPanel(
          "PASSPORT_VIEW",
          Map({ passport: item }),
        );
      },
      [openRightPanel, setSelectedPassportId],
    );

    const { t } = useTranslation("common");

    return (
      <Wrapper>
        <Hidden xs>
          <HeaderRow>
            <TableCol md={3}>
              {t("books.passports.fullName")}
            </TableCol>
            <TableCol md={3}>
              {t("books.passports.serial")} / {t("books.passports.number")}
            </TableCol>
            <TableCol md={3}>
              {t("books.passports.taxId")}
            </TableCol>
            <TableCol md={3}>
              {t("books.passports.issuedDate")}
            </TableCol>
          </HeaderRow>
        </Hidden>
        {passportItems.map((item) => (
          <BooksPassportItemRow
            item={item}
            key={item.get("id")}
            disabled={disabled}
            onFocusPassportItemInPanel={viewPassport}
            selectedPassportId={selectedPassportId}
          />
        ))}
      </Wrapper>
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    selectedPassportId: selectedPassportId,
  }),
  {
    openRightPanel,
    setSelectedPassportId,
  },
);

export default withConnect(BooksPassportsList);

const Wrapper = styled.div`
  width: 100%;
`;

const HeaderRow = styled(TableRow)`
  font-size: 12px;
  color: ${(props) => props.theme.black50};
  border-bottom: 1px solid ${(props) => props.theme.divider};
  cursor: default;
  padding: 0;

  &:hover {
    background-color: transparent;
  }
`;
